import { createRouter, createWebHistory } from "vue-router";
import PublicLayout from "@/layouts/PublicLayout.vue";

const routes = [
  {
    path: "/",
    component: PublicLayout,
    children: [
      { path: "", name: "Home", component: () => import("@/views/Home.vue") },

      { path: "about", name: "AboutUs", component: () => import("@/views/about/AboutUs.vue") },
      { path: "about/founder", name: "Founder", component: () => import("@/views/about/Founder.vue") },
      { path: "about/mentor", name: "Mentor", component: () => import("@/views/about/Mentor.vue") },
      { path: "about/inspiration", name: "Inspiration", component: () => import("@/views/about/Inspiration.vue") },
      { path: "about/gallery", name: "Gallery", component: () => import("@/views/about/Gallery.vue") },
      { path: "about/why-us", name: "WhyUs", component: () => import("@/views/about/WhyUs.vue") },

      { path: "blog", name: "BlogList", component: () => import("@/views/blog/BlogList.vue") },
      { path: "blog/write", name: "WriteBlog", component: () => import("@/views/blog/WriteBlog.vue") },
      { path: "blog/:slug", name: "BlogDetail", component: () => import("@/views/blog/BlogDetail.vue"), props: true },

      { path: "faq/candidate", name: "FaqCandidate", component: () => import("@/views/faq/FaqCandidate.vue") },
      { path: "faq/employer", name: "FaqEmployer", component: () => import("@/views/faq/FaqEmployer.vue") },

      { path: "experts", name: "ExpertsList", component: () => import("@/views/experts/ExpertsList.vue") },
      { path: "experts/join", name: "JoinAsExpert", component: () => import("@/views/experts/JoinAsExpert.vue") },

      { path: "find-jobs", name: "FindJobs", component: () => import("@/views/jobs/FindJobs.vue") },
      { path: "jobs/:id", name: "JobDetail", component: () => import("@/views/jobs/JobDetail.vue"), props: true },

      { path: "profile-highlights", name: "ProfileHighlights", component: () => import("@/views/plans/ProfileHighlights.vue") },

      { path: "build-resume", name: "BuildResume", component: () => import("@/views/resume/BuildResume.vue") },

      { path: "contact", name: "Contact", component: () => import("@/views/contact/ContactUs.vue") },

      { path: "policies/refund", name: "RefundPolicy", component: () => import("@/views/policies/RefundPolicy.vue") },
      { path: "policies/terms", name: "Terms", component: () => import("@/views/policies/Terms.vue") },
      { path: "policies/privacy", name: "Privacy", component: () => import("@/views/policies/Privacy.vue") },

      { path: "register", name: "RegisterLanding", component: () => import("@/views/auth/RegisterLanding.vue") },
      { path: "login", name: "LoginLanding", component: () => import("@/views/auth/LoginLanding.vue") },

      // Generic content page driven by JcSubMenu.Keyword (legacy SUBMENU-CONTENT?SUBMENU=X parity).
      { path: "content/:keyword", name: "SubMenuContent", component: () => import("@/views/SubMenuPage.vue") },
    ],
  },
  { path: "/:pathMatch(.*)*", redirect: "/" },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL || "/"),
  routes,
  scrollBehavior(to, from, saved) {
    if (saved) return saved;
    return { top: 0 };
  },
});

export default router;
